import React from 'react';
import { Button } from './styles';

export default props => <Button {...props} />;
